import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 062452EE-7669-4C36-85E6-A85BBA735348
 * name arrow-up-bold-box
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-box.svg
 * tags
 * - Arrow 
 */
export const ArrowUpBoldBoxIcon = createSvgIcon(<><path d="M19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21M12,7L7,12H10V16H14V12H17L12,7Z" /></>, 'ArrowUpBoldBoxIcon');
export default ArrowUpBoldBoxIcon